import { GuidelineOrigin } from '@treetop/shared/model';

export function isConnectedGuideline(guidelineOrigin?: GuidelineOrigin): boolean {
  return guidelineOrigin === GuidelineOrigin.IMPORTED || guidelineOrigin === GuidelineOrigin.SHARED;
}
